import PhotosInterface from 'interfaces/photo.interface';

export function getProductPreviewPhotoURL(photo: PhotosInterface): string {
    return photo.thumb;
}

export function getProductModalPhotoURL(photo: PhotosInterface): string {
    return photo.large;
}
